import React, { useCallback, useEffect, useState } from "react";

import MUIDataTable from "mui-datatables";

import {
  Chip,
  CircularProgress,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Grid,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";

import { getAiOrders } from "../../apis/cart/apis";
import { RemoveRedEye } from "@mui/icons-material";
import { FilterAutocomplete } from "../../components/Form/FilterAutocomplete";
import { getAllUsers } from "../../apis/user";
export default function AiOrders() {
  const [orders, setOrders] = useState([]);

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);

  const [count, setCount] = useState(0);

  const [filters, setFilters] = useState({});
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [reset, setReset] = useState(false);
  const fetchOrders = useCallback(async () => {
    try {
      setLoading(true);

      const response = await getAiOrders(page + 1, {
        ...filters,
        search: debouncedSearch,
      });

      //   console.log("res is", response);

      setOrders(response.data.results);

      setCount(response.data.count);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, filters, page]);
  const handleUserChange = (name, item) => {
    if (!item?.id) {return;}

    setPage(0);

    setFilters((prev) => ({
      ...prev,
      [name]: item.id,
    }));
  };
  const handleStatusChange = (e) => {
    setPage(0);

    if (!e.target.value) {
      setFilters((prev) => {
        const updated = { ...prev };
        delete updated.status;
        return updated;
      });
      return;
    }

    setFilters((prev) => ({
      ...prev,
      status: e.target.value,
    }));
  };
  const handleReset = () => {
    setFilters({});
    setSearchText("");
    setDebouncedSearch("");
    setPage(0);
    setReset(true);
  };

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "success":
        return "success";

      case "failure": // Existing orders
      case "payment failed": // New orders
        return "error";

      case "payment cancelled":
        return "warning";

      case "pending":
        return "info"; // or "warning" if your MUI version doesn't support "info"

      default:
        return "default";
    }
  };
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
      },
    },

    {
      name: "user",
      label: "User",
      options: {
        filter: false,
        customBodyRender: (value) => value?.name || "-",
      },
    },

    {
      name: "plan",
      label: "Plan",
      options: {
        filter: false,
      },
    },

    {
      name: "number_of_queries",
      label: "No. Of Queries",
      options: {
        filter: false,
      },
    },

    {
      name: "amount",
      label: "Amount",
      options: {
        filter: false,
        customBodyRender: (value) => `₹${value}`,
      },
    },

    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        // filterOptions: {
        //   names: ["SUCCESS", "FAILURE", "PENDING"],
        // },

        customBodyRender: (value) => (
          <Chip label={value} color={getStatusColor(value)} size="small" />
        ),
      },
    },

    {
      name: "payment_id",
      label: "Payment ID",
      options: {
        filter: false,
      },
    },

    {
      name: "updated_at",
      label: "Updated At",
      options: {
        filter: false,
        customBodyRender: (value) =>
          new Date(value).toLocaleString([], {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }),
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        display: false,
        filter: false,

        sort: false,

        customBodyRender: (value) => (
          <IconButton color="primary">
            <RemoveRedEye />
          </IconButton>
        ),
      },
    },
  ];

  const options = {
    selectableRows: "none",

    responsive: "standard",

    elevation: 0,

    rowsPerPage: 10,

    download: false,

    print: false,

    viewColumns: false,

    filter: false,

    search: true,

    sort: false,

    serverSide: true,

    count: count,

    page: page,

    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPage(tableState.page);
      }
    },
    searchText: searchText,
    onSearchChange: (text) => {
      setPage(0);

      setSearchText(text || "");
    },
  };
  return (
    <Box p={2}>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="flex-end"
        sx={{ mb: 2 }}
      >
        {loading && (
          <Grid item>
            <CircularProgress size={20} />
          </Grid>
        )}
        <Grid item md={4} lg={3}>
          <FilterAutocomplete
            fetchOptions={getAllUsers}
            label={"User"}
            name={"user"}
            reset={reset}
            setReset={setReset}
            handleChange={handleUserChange}
          />
        </Grid>

        <Grid item md={3} lg={2}>
          <FormControl
            fullWidth
            size="small"
            sx={{
              "& .MuiInputBase-root": {
                height: 56,
              },
              "& .MuiInputLabel-root": {
                zIndex: 0,
              },
            }}
          >
            <InputLabel>Status</InputLabel>

            <Select
              value={filters.status || ""}
              label="Status"
              onChange={handleStatusChange}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="Success">Success</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Failure">Failure</MenuItem>
              <MenuItem value="Payment Cancelled">Payment Cancelled</MenuItem>
              <MenuItem value="Payment Failed">Payment Failed</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <Button variant="contained" onClick={handleReset}>
            Reset Filters
          </Button>
        </Grid>
      </Grid>

      <MUIDataTable
        title={"Order List"}
        data={orders}
        columns={columns}
        options={options}
      />
    </Box>
  );
}
